import { HeaderFooterLayout } from '../app';
// import RepHeroMobileImage from './images/rep-hero-mobile.png';
// import RepHeroDesktopImage from './images/rep-hero-desktop.png';
import RepTestimonialAvatar1Svg from './images/rep-testimonial-avatar1.svg';
import RepTestimonialAvatar2Svg from './images/rep-testimonial-avatar2.svg';
// import RepMockupMobile from './images/rep-mockup-mobile.png';
// import RepMockupDesktop from './images/rep-mockup-desktop.png';
// import RepWhosItForImage from './images/rep-whositfor-image.png';

import RootContainer from './RootContainer';
import HeroHeaderSection from './HeroHeaderSection';
import HorizontalFeatureSection from './HorizontalFeatureSection';
import SquareFeaturePanel from './SquareFeaturePanel';
import VerticalFeaturePanel from './VerticalFeaturePanel';
import CTACard from './CTACard';
import TestimonialCardsSection from './TestimonialCardsSection';
import MetricsSection from './MetricsSection';
import TestimonialMapSection from './TestimonialMapSection';
import SignUpSection from './SignUpSection';
import TestimonialSection from './TestimonialSection';
import FAQSection from './FAQSection';
import MetaTags from '../util/MetaTags';

const RepHeroMobileImage =
  'https://movingworldspublic.blob.core.windows.net/public/landing/rep/rep-hero-mobile.webp';
const RepHeroDesktopImage =
  'https://movingworldspublic.blob.core.windows.net/public/landing/rep/rep-hero-desktop.webp';
const RepMockupMobile =
  'https://movingworldspublic.blob.core.windows.net/public/landing/rep/rep-mockup-mobile.webp';
const RepMockupDesktop =
  'https://movingworldspublic.blob.core.windows.net/public/landing/rep/rep-mockup-desktop.webp';
const RepWhosItForImage =
  'https://movingworldspublic.blob.core.windows.net/public/landing/rep/rep-whositfor-image.webp';

const SocialEnterprisesPage = () => {
  return (
    <HeaderFooterLayout>
      <MetaTags
        title='Personalized support for social enterprises | MovingWorlds.org'
        description='Get personalized support to grow your revenue and impact'
        imageUrl={RepHeroMobileImage}
      />
      <RootContainer>
        <HeroHeaderSection
          mobileImage={RepHeroMobileImage}
          desktopImage={RepHeroDesktopImage}
          title='Get personalized support to grow your revenue and impact'
          description="We'll match you with skilled volunteers, purpose-aligned partners, and market opportunities that help you move forward—faster."
        />
        <HorizontalFeatureSection
          header="Why it's worth your time"
          description='High quality support, without the price tag.'
          items={[
            {
              icon: 'coins-stacked-01',
              title: 'No cost to you',
              subtitle:
                "There's no cost to participate—this support is fully funded for organizations aligned to our mission.",
            },
            {
              icon: 'lightbulb-02',
              title: 'Support from top professionals ',
              subtitle:
                'Work with skilled volunteers from SAP, EY, and more—experts ready to help you grow.',
            },
            {
              icon: 'chart-breakout-square',
              title: 'Connections for growth',
              subtitle:
                'Tap into a global network of investors, buyers, and partners that support social enterprises.',
            },
          ]}
        />
        <TestimonialSection
          isDesktopLarge
          quote='I feel like I hit the jackpot with the connections and advice I was able to find through
      MovingWorlds and its network of corporate partners.'
          name='Minhaj Chowdhury'
          title='Co-Founder & CEO, Drinkwell'
          avatarSrc={RepTestimonialAvatar1Svg}
        />
        <SquareFeaturePanel
          title='How it Works'
          description='A proven process, guided by technology and backed by real people who care about your growth.'
          items={[
            {
              title: 'Share your business needs',
              description:
                "From marketing to business strategy, tell us what challenge you're working on.",
            },
            {
              title: 'Post a project',
              description:
                'Our tools make it easy to create a project that fits your goals and schedule.',
            },
            {
              title: 'Collaborate on a solution',
              description:
                'Get hands-on support from skilled professionals plus tailored learning resources and events.',
            },
            {
              title: 'Tap into new connections',
              description:
                "Get curated access to funders, buyers, and ecosystem partners when you're ready.",
            },
          ]}
          mobileImage={RepMockupMobile}
          desktopImage={RepMockupDesktop}
          isNumeric
          imageBgColor='light-gray'
        />
        <CTACard
          title='Find the connections you need'
          description='Meet the right people—skilled volunteers, partners, and market connections ready to
            help.'
        />
        <VerticalFeaturePanel
          title="Who's it for"
          description="Whether you're a nonprofit, social enterprise, B Corp, cooperative, or something in between—what matters most is that you're already doing the work."
          subtitle="You're a great fit if you:"
          items={[
            'Earn some revenue from the sale of a product or service',
            'Exist to advance social or environmental goals (like the SDGs)',
            'Have a functioning website and are legally registered',
            "Can show how you're tracking or reporting on your impact",
            'Have at least one full-time team member beyond the founder',
          ]}
          image={RepWhosItForImage}
        />
        <TestimonialSection
          quote="It's really hard being a social entrepreneur. We go through all these pitches, but then never learn what isn't working. Nothing equals the quality of professionals and feedback we have received from MovingWorlds to improve our pitch, operations, and more."
          name='Heather Watkins'
          title='Co-Founder, Bold Reuse'
          avatarSrc={RepTestimonialAvatar2Svg}
        />
        <TestimonialCardsSection
          title="See what's possible"
          description='From building go-to-market strategies to improving financial systems and digital presence — see how other entrepreneurs have used the platform to solve real business challenges with expert help.'
        />
        <MetricsSection
          title='By the numbers'
          description="Join a growing global network of entrepreneurs building what's next."
          items={[
            {
              numberText: '$10k',
              headline: 'In pro bono support per project',
              description:
                'On average, social enterprises receive $10,000 worth of strategic business support per project',
            },
            {
              numberText: '110',
              headline: 'Countries reached',
              description:
                'Enterprises around the world have used our platform to get support—no matter their location.',
            },
            {
              numberText: '2,500',
              headline: 'Successful matches',
              description:
                'Purpose-driven collaborations built to create lasting, on-the-ground change.',
            },
            {
              numberText: '10,000+',
              headline: 'Volunteer hours contributed',
              description: 'Time invested by professionals supporting real business challenges.',
            },
          ]}
        />
        <TestimonialMapSection />
        <SignUpSection
          title='Ready to get started?'
          description='Create your free account to unlock the support and connections your business needs to grow.'
        />
        <FAQSection
          items={[
            {
              question: 'Is it really free?',
              answer: (
                <p>
                  Yes - it's really free! There are no hidden fees, no trial periods, and no
                  upsells. Our work is fully funded by corporate partners who are investing in the
                  social enterprise movement—by sharing their employees, networks, and resources to
                  help you grow. That's what makes it possible for us to offer personalized support
                  at no cost to you.
                </p>
              ),
            },
            {
              question: 'What kind of support can I get?',
              answer: (
                <div className='flex flex-col gap-2'>
                  We offer multiple ways to help your organization grow. Through your dashboard,
                  you'll have access to:
                  <p>
                    ✔ Expert volunteers from top global companies: Get matched with professionals
                    from companies like SAP, EY, and F5 who bring skills in marketing, finance,
                    strategy, operations, tech, and more.
                  </p>
                  <p>
                    ✔ Practical learning and live events: Access templates, tools, and self-paced
                    courses, plus live sessions with experts, impact investors, and other social
                    enterprise leaders.
                  </p>
                  <p>
                    ✔ Intros to buyers, partners, and funders: We'll help you connect with relevant
                    opportunities—whether that's corporate partners, procurement teams, or aligned
                    accelerators and investors. This is support you can actually use—tailored to
                    your needs, available on your schedule, and backed by real people who care about
                    your growth.
                  </p>
                </div>
              ),
            },
            {
              question: 'How much time do I need to commit?',
              answer: (
                <div>
                  We know your time is limited—that's why our support is flexible and on-demand. To
                  get the most out of the platform, we recommend:
                  <ul className='mt-2 list-disc ml-4 '>
                    <li>
                      About 2 hours per week in your first month to explore opportunities, post your
                      first project, and engage with the community.
                    </li>
                    <li>
                      As little as 20 minutes per week after that to stay connected and access new
                      resources as needed. You're in control—and the more you engage, the more value
                      you'll unlock.
                    </li>
                  </ul>
                </div>
              ),
            },
            {
              question: "What if I don't know what I need support with?",
              answer: (
                <div className='flex flex-col gap-2'>
                  <p>You're not alone—and that's exactly what we're here for.</p>
                  <p>
                    Start by taking our Scale-Up Assessment, a quick but powerful tool that helps
                    you identify where support can make the biggest difference. From there, you can
                    book a 1:1 call with our Entrepreneur-in-Residence, who will walk through your
                    results and help you prioritize next steps.
                  </p>
                  <p>
                    If you're feeling stuck or uncertain, we'll help you focus your energy where it
                    matters most.
                  </p>
                </div>
              ),
            },
            {
              question: 'What are the application requirements?',
              answer:
                "The application takes about 25 minutes to complete. You'll be asked a few questions about your business—like your team size, revenue, and funding—so it helps to have those details ready.",
            },
          ]}
        />
      </RootContainer>
    </HeaderFooterLayout>
  );
};

export default SocialEnterprisesPage;
